module.exports = __webpack_public_path__ + "media/dorobek/assets/images/exclamation-mark-orange-250ded0c21373246ae3e84b4d73891a9.svg";